<template lang="pug">
.loaded-content-wrapper.d-flex.flex-column
  template(v-if='isLoading')
    .py-4.flex-fill
      LoadingIndicator

  template(v-else)
    template(v-if='data === null')
      LoadingError(
        :title='loadingErrorMessage'
        @reload='$emit("reload")'
      )

    //- template(v-else-if='data === []')
    //-   .text-medium.px-4.py-4
    //-     | ยังไม่มีข้อมูล

    template(v-else)
      slot
</template>

<script>
export default {
  props: {
    isLoading: { default: false },
    data: { default: null },
    loadingErrorMessage: {
      default: 'เกิดปัญหาในการโหลดข้อมูล',
    },
  },
};
</script>

<style lang="scss">
// .loaded-content-wrapper {}
</style>
